import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDashboardPathForRole, getEffectiveRole } from "../utils/authRoutes";
import { isAuthSessionValid } from "../utils/authSession";
import { isStandaloneDisplayMode } from "../pwa/pwaDetection";

/** Unknown paths: send authenticated users to their dashboard, everyone else to home. */
export default function DefaultAppRedirect() {
    const { currentUser, currentRole } = useSelector((state) => state.user);
    const role = getEffectiveRole(currentRole, currentUser);
    if (role && currentUser && isAuthSessionValid(currentUser)) {
        const dashboard = getDashboardPathForRole(role, currentUser);
        if (dashboard) {
            return <Navigate to={dashboard} replace />;
        }
    }
    return <Navigate to={isStandaloneDisplayMode() ? "/login" : "/"} replace />;
}
